const constantsData = {
    buttons: {
        apply: "Apply",
        back: "Back",
        backToHome: "Back to home",
        cancel: "Cancel",
        closeFilters: "Close filters",
        create: "Create",
        delete: "Delete",
        edit: "Edit",
        openFilters: "Open filters",
        reset: "Reset",
        save: "Save",
        view: "View",
    },
    hostUrl: "https://tasks-galaxy.netlify.app",
    inputs: {
        description: {
            label: "Description",
            name: "description",
        },
        dueData: {
            label: "Due Data",
            name: "dueDate",
        },
        dueDateFrom: {
            label: "Due Date From",
            name: "dueDateFrom",
        },
        dueDateTo: {
            label: "Due Date To",
            name: "dueDateTo",
        },
        priority: {
            label: "Priority",
            name: "priority",
        },
        status: {
            label: "Status",
            name: "status",
        },
        title: {
            label: "Title",
            name: "title",
        },
    },
    labels: {
        createdAt: "Created At",
        darkMode: "Dark Mode",
        description: "Description",
        dueDate: "Due Date",
        lightMode: "Light Mode",
        priority: "Priority",
        searchTasks: "Search Tasks",
        status: "Status",
        updatedAt: "Updated At",
    },
    metaDescription: "Tasks Galaxy is a smart task management dashboard App that allows you to organize and add your daily tasks including other features, like drag & drop and changing task status from to-do status to in-progress, pending, or done status.",
    metaKeywords: "tasks, galaxy, task management, dashboard, organize, daily tasks, drag & drop, task status, to-do, in-progress, pending, done",
    msgs: {
        dateEarlier: "Due Date From must be earlier than Due Date To, please be sure that you enter a valid Due Date TO",
        dateLater: "Due Date To must be later than Due Date From, please be sure that you enter a valid Due Date From",
        tasks: {
            creatingTask: "Creating task...",
            deleteTaskConfirmation: "Are you sure you want to delete this task?",
            deletingTask: "Deleting task...",
            editingTask: "Editing task...",
            form: {
                requiredDescription: "Description is required",
                requiredDueDate: "Due Date is required",
                requiredPriority: "Priority is required",
                requiredStatus: "Status is required",
                requiredTitle: "Title is required",
            },
            taskCreated: "Task created successfully",
            taskDeleted: "Task deleted successfully",
            taskEdited: "Task saved successfully",
        },
    },
    noOptions: "No options",
    priorities: {
        high: "High",
        low: "Low",
        medium: "Medium",
    },
    titles: {
        allRightsReserved: "All Rights Reserved",
        author: "Mohamed Elhawary",
        createTask: "Create Task",
        editTask: "Edit Task",
        madeBy: "Made By",
        notFound: "Not found",
        tasksGalaxy: "Tasks Galaxy",
        tasksList: "Tasks List",
    },
};

export default constantsData;
